import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e8c6961"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OTabelaDestravarPeriodo__Conteudo",
  "data-testid": "OTabelaDestravarPeriodo"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", {
  "aria-hidden": "",
  class: "OTabelaDestravarPeriodo__IconeLapis pi pi-pencil"
}, null, -1))
const _hoisted_3 = { class: "OTabelaDestravarPeriodo__Footer" }

import { computed, onMounted, ref } from "vue"
  import Column from "primevue/column"
  import Calendar from "primevue/calendar"
  import DataTable from "primevue/datatable"
  import {
    ItemDeProjetoComPeriodoTravado,
    estruturarDadosDeProjetosParaEdicaoNaTabela,
  } from "./OTabelaDestravarPeriodo.script"
  import { estados } from "@/types/api"
  import { TravamentosRepositorio } from "@/repositorios/travamento/travamento.repositorio"
  import {
    ItemDeDestravamento,
    ListarControlador,
    DestravarPeriodo,
  } from "@/repositorios/travamento/travamento.modelo"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarProjetos,
    ParamsProjeto,
  } from "@/repositorios/projeto/projeto.modelo"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { AEstadoVazioTabela, MBotoesRodape } from "@/components/Gerais"
  import { useRouter } from "vue-router"
  import { useI18n } from "vue-i18n"

  /* interfaces */
  interface EmitirVisibilidade {
    (event: "periodoDestravado"): void
  }

  /* emitters */
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaDestravarPeriodo',
  emits: ["periodoDestravado"],
  setup(__props, { emit: emitir }: { emit: ({
    (event: "periodoDestravado"): void
  }), expose: any, slots: any, attrs: any }) {

  

  const { t } = useI18n()

  /* composables */
  const { leitor, resolverLeitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { onErro, onSucesso } = usarMensagemUsuario()
  const router = useRouter()
  const {
    formatarDataNoPadraoTimesheet,
    converterStringParaData,
    pegarSomenteData,
  } = usarDataHora()

  /* dados */
  const itensDeProjetosComPeriodoTravado = ref<
    ItemDeProjetoComPeriodoTravado[]
  >([])
  const estagioDaRequisicao = ref<number>(estados.INICIAL)
  const rotuloBotaoSalvar = t("salvarAlteracoes")
  const travandoPeriodo = computed(
    () => estagioDaRequisicao.value === estados.PEDENTE
  )

  const possuiItensEditados = computed(() => {
    return !itensDeProjetosComPeriodoTravado.value.some((item) => item.editado)
  })

  const botaoSalvarDesabilitado = computed(() => {
    return possuiItensEditados.value
  })

  const projetoRep = new ProjetoRepositorio({ utilizaCache: true })
  const travamentosRep = new TravamentosRepositorio({ utilizaCache: true })
  const lerControladores = leitor<ListarControlador, {}>(
    travamentosRep.visualizarControladores,
    {
      "por-pagina": 1000,
    }
  )
  const lerProjetos = leitor<ListarProjetos, ParamsProjeto>(
    projetoRep.listarProjetosFrontend,
    {
      "ordenar-por": ["asc.nome_projeto"],
      "por-pagina": 1000,
    }
  )
  const destravarPeriodosEscritor = escritor<{ id: string }, DestravarPeriodo>(
    travamentosRep.destravarPeriodo,
    []
  )

  const existemProjetosParaCarregar = ref(true)

  const carregandoControladores = computed(() => {
    return lerControladores.resultado.status === "pendente"
  })

  const carregandoProjetos = computed(() => {
    return (
      lerProjetos.resultado.status === "pendente" &&
      existemProjetosParaCarregar.value
    )
  })

  const estilo = {
    dialogo: {
      style: {
        width: "70%",
      },
      contentStyle: {
        height: "70vh",
      },
    },
    colunas: {
      projetosTravados: {
        maxWidth: "70%",
      },
      primeiroDiaDestravado: {
        maxWidth: "30%",
        justifyContent: "end",
        width: "100px",
      },
    },
    linhas: {
      alturaDaLinha: {
        height: "70px",
        minHeight: "28px",
      },
    },
    tabela: {
      alturaDaRolagemVertical: "calc(100vh - 265px)",
      position: "unset !important",
    },
    calendario: {
      input: {
        maxWidth: "120px",
        minWidth: "unset",
      },
    },
  }

  /* métodos */
  const aplicarFormatacaoDeData = (data: Date | string) => {
    const dataComoDate = converterStringParaData(data)
    return formatarDataNoPadraoTimesheet(dataComoDate)
  }

  const cancelarDestravamento = () => {
    router.push({ path: "/atividades" })
  }

  const definirItemDeProjetoComoEditado = (index) => {
    const item = itensDeProjetosComPeriodoTravado.value[index]
    item.editado = true
  }

  const definirEstagioDaRequisicaoComoInicial = () => {
    estagioDaRequisicao.value = estados.INICIAL
  }

  const definirEstagioDaRequisicaoComoPendente = () => {
    estagioDaRequisicao.value = estados.PEDENTE
  }

  const definirEstagioDaRequisicaoComoErro = () => {
    estagioDaRequisicao.value = estados.ERRO
  }

  const definirEstagioDaRequisicaoComoSucesso = () => {
    estagioDaRequisicao.value = estados.SUCESSO
  }

  const montarDestravamentoDePeriodo = (): DestravarPeriodo => {
    const mapearDadosParaEnvio = (projeto: ItemDeProjetoComPeriodoTravado) => {
      return {
        idProjeto: projeto.idProjeto,
        primeiraDataDestravada: pegarSomenteData(
          converterStringParaData(projeto.primeiroDiaDestravado)
        ),
      } as ItemDeDestravamento
    }

    return {
      periodosParaDestravar: itensDeProjetosComPeriodoTravado.value
        .filter((item) => item.editado)
        .map(mapearDadosParaEnvio),
    }
  }

  const executarEscritorDeDestravarPeriodo = async (
    destravamentoDePeriodo: DestravarPeriodo
  ) => {
    const darRetornoDeSucessoProUsuario = async () => {
      onSucesso({
        resumo: t('periodoDestravadoComSucesso'),
        detalhes: "",
      })
      definirEstagioDaRequisicaoComoSucesso()
      emitir("periodoDestravado")
      await inicializarTabelaComPeriodosTravados()
    }

    const darRetornoDeErroProUsuario = () => {
      onErro({
        resumo: t('naoFoiPossivelDestravarPeriodo'),
        detalhes: "",
      })
      definirEstagioDaRequisicaoComoErro()
    }

    destravarPeriodosEscritor.mudarArgumentos([destravamentoDePeriodo])

    await destravarPeriodosEscritor.executar()

    resolver<{ id: string }>(destravarPeriodosEscritor.resultado, {
      sucesso: darRetornoDeSucessoProUsuario,
      erro: darRetornoDeErroProUsuario,
    })
  }

  const destravarPeriodo = async () => {
    definirEstagioDaRequisicaoComoPendente()

    const destravamentoDePeriodo = montarDestravamentoDePeriodo()
    await executarEscritorDeDestravarPeriodo(destravamentoDePeriodo)
    definirEstagioDaRequisicaoComoInicial()
  }

  const buscarIdsDosProjetosComPeriodosTravados = (
    controladores: ListarControlador[]
  ) => {
    const verificarSeControladorPossuiAlgumPeriodoTravado = (
      controlador: ListarControlador
    ) => {
      return controlador.periodos.some((periodo) => periodo.travado === true)
    }

    const controladoresComPeriodosTravados = controladores.filter(
      verificarSeControladorPossuiAlgumPeriodoTravado
    )

    return controladoresComPeriodosTravados.map(
      (controlador) => controlador.projetoId
    )
  }

  const processarResultadoDeSucessoNaLeituraDosProjetos = () => {
    if (
      lerProjetos.resultado.status === "sucesso" &&
      lerControladores.resultado.status === "sucesso"
    ) {
      const controladores = lerControladores.resultado.dados
      const projetos = lerProjetos.resultado.dados

      itensDeProjetosComPeriodoTravado.value =
        estruturarDadosDeProjetosParaEdicaoNaTabela(controladores, projetos)
    }
  }

  const processarResultadoDeSucessoNaLeituraDosControladores = async (
    listaDeControladores: ListarControlador[]
  ) => {
    const idsDosProjetosComTravamentos =
      buscarIdsDosProjetosComPeriodosTravados(listaDeControladores)

    if (idsDosProjetosComTravamentos.length === 0) {
      existemProjetosParaCarregar.value = false
      return
    }

    const idsFormatadosParaQuery = idsDosProjetosComTravamentos.join(",")
    lerProjetos.incrementarParametros({
      id: `em.(${idsFormatadosParaQuery})`,
    })
    await lerProjetos.executar()

    resolverLeitor<ListarProjetos>(lerProjetos.resultado, {
      sucesso: processarResultadoDeSucessoNaLeituraDosProjetos,
    })
  }

  const inicializarTabelaComPeriodosTravados = async () => {
    await lerControladores.executar()

    resolverLeitor<ListarControlador>(lerControladores.resultado, {
      sucesso: processarResultadoDeSucessoNaLeituraDosControladores,
    })
  }

  /* lifecyles */
  onMounted(async () => {
    inicializarTabelaComPeriodosTravados()
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(DataTable), {
        id: "OTabelaDestravarPeriodo__TabelaProjetosTravados",
        "aria-describedby": "OTabelaDestravarPeriodo__LegendaDaTabela",
        "data-testid": "OTabelaDestravarPeriodo__TabelaProjetosTravados",
        "edit-mode": "cell",
        "filter-display": "menu",
        loading: _unref(carregandoProjetos) || _unref(carregandoControladores),
        "row-style": estilo.linhas.alturaDaLinha,
        "scroll-height": estilo.tabela.alturaDaRolagemVertical,
        scrollable: "",
        value: (itensDeProjetosComPeriodoTravado.value as ItemDeProjetoComPeriodoTravado[])
      }, _createSlots({
        loading: _withCtx(() => [
          _createVNode(_component_Skeleton, {
            height: "100%",
            width: "100%"
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            class: "OTabelaDestravarPeriodo__Coluna OTabelaDestravarPeriodo__ProjetosTravados",
            field: "nome",
            header: _unref(t)('projetosTravados'),
            "show-filter-operator": true,
            sortable: true,
            style: _normalizeStyle(estilo.colunas.projetosTravados)
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(data.nome), 1)
            ]),
            _: 1
          }, 8, ["header", "style"]),
          _createVNode(_unref(Column), {
            id: "OTabelaDestravarPeriodo__PrimeiroDiaDestravado",
            class: "OTabelaDestravarPeriodo__Coluna OTabelaDestravarPeriodo__PrimeiroDiaDestravado",
            field: "primeiroDiaDestravado",
            header: _unref(t)('primeiroDiaDestravado'),
            "show-filter-operator": true,
            sortable: true,
            style: _normalizeStyle(estilo.colunas.primeiroDiaDestravado)
          }, {
            body: _withCtx(({ data, index }) => [
              _createElementVNode("div", {
                class: _normalizeClass(["OTabelaDestravarPeriodo__DataEditavel", {
              'OTabelaDestravarPeriodo__DataEditavel--editado':
                itensDeProjetosComPeriodoTravado.value[index].editado,
            }]),
                "data-testid": "OTabelaDestravarPeriodo__DataEditavel"
              }, [
                _createTextVNode(_toDisplayString(aplicarFormatacaoDeData(data.primeiroDiaDestravado)) + " ", 1),
                _hoisted_2
              ], 2)
            ]),
            editor: _withCtx(({ index }) => [
              _createVNode(_unref(Calendar), {
                modelValue: 
              itensDeProjetosComPeriodoTravado.value[index].primeiroDiaDestravado
            ,
                "onUpdate:modelValue": [($event: any) => ((
              itensDeProjetosComPeriodoTravado.value[index].primeiroDiaDestravado
            ) = $event), ($event: any) => (definirItemDeProjetoComoEditado(index))],
                "append-to": "self",
                class: "OTabelaDestravarPeriodo__EditorDeData",
                "data-testid": "OTabelaDestravarPeriodo__EditorDeData",
                "input-style": estilo.calendario.input,
                "max-date": 
              itensDeProjetosComPeriodoTravado.value[index]
                .primeiroDiaDestravadoOriginal
            
              }, null, 8, ["modelValue", "onUpdate:modelValue", "input-style", "max-date"])
            ]),
            _: 1
          }, 8, ["header", "style"])
        ]),
        _: 2
      }, [
        (!_unref(carregandoControladores) && !_unref(carregandoProjetos))
          ? {
              name: "empty",
              fn: _withCtx(() => [
                _createVNode(_unref(AEstadoVazioTabela))
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["loading", "row-style", "scroll-height", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(MBotoesRodape), {
        onCancelar: cancelarDestravamento,
        onSalvar: destravarPeriodo,
        carregando: _unref(travandoPeriodo),
        desabilitado: _unref(botaoSalvarDesabilitado),
        "rotulo-botao-confirmar": _unref(rotuloBotaoSalvar)
      }, null, 8, ["carregando", "desabilitado", "rotulo-botao-confirmar"])
    ])
  ], 64))
}
}

})